module.exports = __webpack_public_path__ + "static/media/nike-ksa-what-if-you-can.c7e64645.mp4";